const BASE_URL = process.env.VUE_APP_URL_DEV || 'http://localhost:8080'

function authHeaders(extra = {}) {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : ''
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...extra,
    }
}

function buildQuery(params = {}) {
    const q = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '') continue
        q.append(key, value)
    }
    const qs = q.toString()
    return qs ? '?' + qs : ''
}

async function jsonFetch(url, options = {}) {
    const response = await fetch(url, {
        ...options,
        headers: authHeaders(options.headers || {}),
    })
    const body = await response.json().catch(() => ({}))
    if (!response.ok) {
        const error = new Error(body?.message || `Request failed: ${response.status}`)
        error.status = response.status
        error.payload = body
        throw error
    }
    return body?.data ?? body
}

export async function fetchPaymentOrders(params = {}) {
    const data = await jsonFetch(`${BASE_URL}/api/payments/orders${buildQuery(params)}`)
    return {
        items: data?.items || [],
        meta: data?.meta || { current_page: 1, last_page: 1, per_page: 20, total: 0 },
    }
}

export function formatOrderPrice(amountCents) {
    if (amountCents === null || amountCents === undefined) return '—'
    const rub = Number(amountCents) / 100
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        maximumFractionDigits: 0,
    }).format(rub)
}

export function formatOrderStatus(status) {
    const map = {
        pending: 'Ожидает оплаты',
        paid: 'Оплачен',
        failed: 'Ошибка',
    }
    return map[status] || status
}

export function formatProductType(type) {
    const map = {
        tier: 'Тариф',
        dashboard: 'Дашборд',
        chat_plan: 'AI-чат',
        chat_addon: 'AI-чат аддон',
        payment_link: 'Ссылка на оплату',
    }
    return map[type] || type
}
